import { PlatformLicenseActivationDTO, PlatformLicenseDTO, PlatformLicensePricingDTO } from '@iota/iota-management-portal-v4-client';
import { createAction, props } from '@ngrx/store';

export const LoadPlatformLicenses = createAction('[PlatformLicense] LoadPlatformLicenses');
export const LoadPlatformLicensesSuccess = createAction(
    '[PlatformLicense] LoadPlatformLicensesSuccess',
    props<{ platformLicenses: PlatformLicenseDTO[] }>()
);
export const LoadPlatformLicensesFailure = createAction('[PlatformLicense] LoadPlatformLicensesFailure', props<{ error: any }>());

export const LoadPlatformLicensesById = createAction('[PlatformLicense] LoadPlatformLicensesById', props<{ platformLicenseId: string }>());
export const LoadPlatformLicensesByIdSuccess = createAction(
    '[PlatformLicense] LoadPlatformLicensesByIdSuccess',
    props<{ platformLicense: PlatformLicenseDTO }>()
);
export const LoadPlatformLicensesByIdFailure = createAction('[PlatformLicense] LoadPlatformLicensesByIdFailure', props<{ error: any }>());

export const UpsertPlatformLicense = createAction(
    '[PlatformLicense] UpsertPlatformLicense',
    props<{ platformLicense: PlatformLicenseDTO }>()
);
export const UpsertPlatformLicenseSuccess = createAction(
    '[PlatformLicense] UpsertPlatformLicenseSuccess',
    props<{ platformLicenseId: string }>()
);
export const UpsertPlatformLicenseFailure = createAction('[PlatformLicense] UpsertPlatformLicenseFailure', props<{ error: any }>());

export const UpsertPlatformLicensePricing = createAction(
    '[PlatformLicense] UpsertPlatformLicensePricing',
    props<{ platformLicenseId: string; platformLicensePricing: PlatformLicensePricingDTO }>()
);
export const UpsertPlatformLicensePricingSuccess = createAction(
    '[PlatformLicense] UpsertPlatformLicensePricingSuccess',
    props<{ platformLicenseId: string }>()
);
export const UpsertPlatformLicensePricingFailure = createAction(
    '[PlatformLicense] UpsertPlatformLicensePricingFailure',
    props<{ error: any }>()
);

export const DeletePlatformLicensePricing = createAction(
    '[PlatformLicense] DeletePlatformLicensePricing',
    props<{ platformLicenseId: string; platformLicensePricingId: string }>()
);
export const DeletePlatformLicensePricingSuccess = createAction(
    '[PlatformLicense] DeletePlatformLicensePricingSuccess',
    props<{ platformLicenseId: string }>()
);
export const DeletePlatformLicensePricingFailure = createAction(
    '[PlatformLicense] DeletePlatformLicensePricingFailure',
    props<{ error: any }>()
);

export const LoadPlatformLicensePricingsThatHaveNotBeenInvoiced = createAction(
    '[PlatformLicense] LoadPlatformLicensePricingsThatHaveNotBeenInvoiced',
    props<{ platformLicenseId: string }>()
);
export const LoadPlatformLicensePricingsThatHaveNotBeenInvoicedSuccess = createAction(
    '[PlatformLicense] LoadPlatformLicensePricingsThatHaveNotBeenInvoicedSuccess',
    props<{ pricingIdsThatHaveNotBeenInvoiced: string[] }>()
);
export const LoadPlatformLicensePricingsThatHaveNotBeenInvoicedFailure = createAction(
    '[PlatformLicense] LoadPlatformLicensePricingsThatHaveNotBeenInvoicedFailure',
    props<{ error: any }>()
);

export const LoadPlatformLicenseActivationsThatUseLicense = createAction(
    '[PlatformLicense] LoadPlatformLicenseActivationsThatUseLicense',
    props<{ platformLicenseId: string }>()
);
export const LoadPlatformLicenseActivationsThatUseLicenseSuccess = createAction(
    '[PlatformLicense] LoadPlatformLicenseActivationsThatUseLicenseSuccess',
    props<{ platformLicenseActivations: PlatformLicenseActivationDTO[]; platformLicenseId: string }>()
);

export const PlatformLicenseActionFailure = createAction('[PlatformLicense] PlatformLicenseActionFailure', props<{ error: any }>());
